import * as actions from "../actions/Type";
import primary_logo from "../assets/images/z_1.png";
import logo from "../assets/images/z_logo.png";
import footer_logo from "../assets/images/z_2.png";
import primary_logo_bill from "../assets/images/z_1.png";
import footer_logo_bill from "../assets/images/z_2.png";
const intialState = {
  lang: "krd",
  primarycolor: "#18a99e",
  secondarycolor: "#18a99e",
  thirdcolor: "#18a99e",
  primary_logo: primary_logo,
  footer_logo: footer_logo,
  logo_print_list: primary_logo,
  logo: logo,
  primary_logo_bill,
  footer_logo_bill,
  name_en: "Zangin RealEstate",
  name_arb: "عقارات زنگین",
  name_krd: "عقارات زەنگین",
};
const HelperReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.CHANGE_LANGE_KURDISH:
      return {
        ...state,
        lang: action.payload,
      };
    case actions.CHANGE_LANGE_ENGLISH:
      return {
        ...state,
        lang: action.payload,
      };
    case actions.CHANGE_LANGE_ARABIC:
      return {
        ...state,
        lang: action.payload,
      };
    default:
      return { ...state };
  }
};

export default HelperReducer;
